import { useT } from "@/i18n";

const CHIP_CLASS = "shrink-0 rounded-full px-3 py-1 text-center caption font-extrabold";

/** Where an assignment stands: done or not, with lateness as its own badge beside it. */
export function HomeworkStatusChip({
  isComplete,
  isLate,
}: { isComplete: boolean; isLate: boolean }) {
  const t = useT();

  const { label, tone } = isComplete
    ? { label: t["homework.status.done"], tone: "bg-app-mint text-green-950" }
    : isLate
      ? { label: t["homework.status.overdue"], tone: "bg-app-overdue/10 text-app-overdue" }
      : { label: t["homework.status.undone"], tone: "bg-gray-100 text-gray-600" };

  return (
    <span className="inline-flex shrink-0 items-center gap-1.5">
      <span className={`${CHIP_CLASS} min-w-[4.5rem] ${tone}`}>{label}</span>
      {isComplete && isLate && (
        <span className={`${CHIP_CLASS} bg-warning-100 text-warning-700`}>
          {t["homework.status.late"]}
        </span>
      )}
    </span>
  );
}
